import React from 'react'
import { Upload, Form, Icon, Input, Button, Row, Col, DatePicker } from 'antd';

export const ConsentFormStep4 = (props) => {
    if (props.currentStep !== 'Step 4') {
      return null
    }
    return(
      <div className="form-group">


            <h3 style={{ display: 'inline-block !important' }}>{!props.token && (props.consentExistsMethodType === 'Email' || props.consentExistsMethodType === 'EmailRegainedCapacity') ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!' }</h3>

            {props.siteID && <h4 style={{ display: 'inline-block !important' }}>Site ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.siteID}</span></h4>}
            {props.userID && <h4 style={{  display: 'inline-block !important' }}>User ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.userID}</span></h4>}
            <h4 style={{  display: 'inline-block !important' }}>Subject ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.subjectID}</span></h4>
            <h4 style={{ display: 'inline-block !important' }}>Consent Type: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.consentExistsPersonType}</span></h4>
            <h4 style={{ display: 'inline-block !important' }}>Consent Method: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.consentExistsMethodType}</span></h4>
            {['Email', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && <h4 style={{  display: 'inline-block !important' }}>Consent Email Status: <h5 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.consentExistsEmailStatus.replace(/_/g, ' ')}</h5></h4>}
            <h4 style={{  display: 'inline-block !important' }}>Document Link: <span style={{ color: '#4CDEF5', display: 'inline-block' }}><a href={props.consentExistsLink} target="_blank">Consent Document</a></span></h4>

      </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeRedDeerCalgary/Step4.js